/* @flow
 *
 * Component that renders a list of cards on the home with content for
 * children. It can be filtered and loads new content on the press of a button
 * or scroll.
 */

import React from 'react';
import { debounce } from 'lodash';
import moment from 'moment';
import 'moment/locale/nl';
import PaginatingCollection from '../CardCollection/PaginatingCollection';

type Props = {
  initialItems: Array<string>,
  initialPagePath: string,
};

type State = {
  items: Array<Object>,
  pagePath: string,
  isLoading: boolean,
  scrollPosition: number,
  isFirstPage: boolean,
  showTopButton: boolean,
}

export default class MissedBroadcasts extends React.PureComponent<Props, State> {
  actions: Object;

  constructor(props: Props): void {
    moment.locale('nl');
    super(props);
    this.state = {
      items: this.props.initialItems.map(item => JSON.parse(item)),
      previousSize: 0,
      pagePath: this.props.initialPagePath,
      isLoading: false,
      scrollPosition: window.scrollY,
      isFirstPage: true,
      showTopButton: false,
    };
  }

  componentDidMount(): void {
    window.addEventListener('scroll', debounce(() => {
      if (!this.state.showTopButton && window.scrollY > screen.height * 1.5) {
        this.setState({ showTopButton: true });
      } else if (this.state.showTopButton && window.scrollY < screen.height * 1.5) {
        this.setState({ showTopButton: false });
      }
    }, 200));
  }

  /* Checks to see if new items should be loaded.
   */
  startLoading = (): void => {
    if (this.state.isFirstPage) {
      return;
    }
    this.actions.startLoading();
  };

  loadNextPage = (): void => {
    if (this.state.pagePath === null || this.state.isLoading) {
      return;
    }
    this.setState(prevState => ({
      ...prevState,
      isLoading: true,
      isFirstPage: false,
    }));
    $.getJSON(this.state.pagePath,
      (res) => {
        this.setState(prevState => ({
          ...prevState,
          items: prevState.items.concat(res.broadcasts),
          pagePath: res.links.next,
          isFirstPage: false,
          isLoading: false,
          showTopButton: true,
        }));
      },
    );
  }

  formatDate = (date: Date): string => moment(date).format('DD MMMM YYYY [om] HH:MM');

  moveToTop = () => {
    window.scrollTo(0, 0);
    this.setState({ showTopButton: false });
  }

  episodeUrl = (item: Object): string => `/kinderfilmpjes/programmas/${item.serie.slug}/gemist/${item.mid}`

  renderTopButton = () =>
    <div className="btn__top" onClick={this.moveToTop} />

  // Prefer the full image URL the API already provides (image.upload_file_path).
  // For MDH-imported items that URL is the MDH CDN; the legacy poms id can no
  // longer be rebuilt into a correct URL (those ids collide with unrelated
  // images on images.poms.omroep.nl). Fall back to the legacy build only when
  // the API gives no full URL.
  imageSrc = (image: { id: string, upload_file_path?: string }):string =>
    image.upload_file_path || `https://images.poms.omroep.nl/image/s400x400/${image.id}.jpg`

  render(): React$Element<any> {
    return (
      <PaginatingCollection startLoading={() => !this.state.isFirstPage && this.loadNextPage()} className="l-row u-margin-top">
        {this.state.items.map(item => (
          <div key={item.id} className="l-col-4-l l-col-6-s">
            <a className="card card--inline" href={this.episodeUrl(item)} >
              <div className="card__image ratio ratio--16x9">
                <img loading="lazy" alt={item.title} src={this.imageSrc(item.image)} className="item__image" />
              </div>
              <div className="card__overlay">
                {item.title}
                <br />
                {this.formatDate(item.start)}
              </div>
            </a>
          </div>
        ))}
        {this.state.isLoading && <div className="spinner spinner--tabbar" />}
        {this.state.isFirstPage && (
          <button
            className="btn load-more-button"
            onClick={this.loadNextPage}
          >
            <img src="/assets/icons/plus-green.svg" className="plus-icon" alt="plus" />
          </button>
        )}
        {this.state.showTopButton && !this.state.isFirstPage && this.renderTopButton()}
      </PaginatingCollection>
    );
  }
}
